import style from "./contact.module.css";

function Contact() {
  return (
    <section className={style.contact_section} id='contact'>
      <div className={style.contact_container}>
        <div className={style.section_header}>
          <h1 className={style.section_title}>Contact</h1>
          <div className={style.title_underline}></div>
          <h3 className={style.section_subtitle}>Don't be shy, hit me up!</h3>
        </div>
        
        <div className={style.contact_cards}>
          {/* Location */}
          <div className={style.contact_card}>
            <div className={style.icon_wrapper}>
              <i className="fa-solid fa-location-dot"></i>
            </div>
            <div className={style.contact_info}>
              <h4>Location</h4>
              <p>Kathmandu, Nepal</p>
            </div>
          </div>
          
          {/* Email */}
          <div className={style.contact_card}>
            <div className={style.icon_wrapper}>
              <i className="fa-solid fa-envelope"></i>
            </div>
            <div className={style.contact_info}>
              <h4>E-Mail</h4>
              <p>Mahtop324@gmail.com</p>
            </div>
          </div>
          
          {/* Phone - New addition */}
          <div className={style.contact_card}>
            <div className={style.icon_wrapper}>
              <i className="fa-solid fa-phone"></i>
            </div>
            <div className={style.contact_info}>
              <h4>Phone</h4>
              <p>+977 9800841208</p>
            </div>
          </div>
        </div>
        
        <div className={style.contact_form_container}>
          <h3 className={style.form_title}>Send Me a Message</h3>
          <form className={style.contact_form}>
            <div className={style.form_row}>
              <div className={style.form_group}>
                <input type="text" placeholder="Your Name" className={style.form_input} required />
              </div>
              <div className={style.form_group}>
                <input type="email" placeholder="Your Email" className={style.form_input} required />
              </div>
            </div>
            <div className={style.form_group}>
              <input type="text" placeholder="Subject" className={style.form_input} required />
            </div>
            <div className={style.form_group}>
              <textarea placeholder="Your Message" className={style.form_textarea} rows="5" required></textarea>
            </div>
            <button type="submit" className={style.submit_button}>
              Send Message <i className="fa-solid fa-paper-plane"></i>
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default Contact;